import React from 'react';
import PropTypes from 'prop-types';

import { ElementClickTracker } from '../../analytics/cohesion';
import { ELEVATED_CAMPAIGN_PROMO_UI } from '../../constants/elevatedCampaignPromoUi';
import { SIGN_UP_ELEVATE_PRESENCE_TRACKING } from '../../constants/subscriptions';
import CampaignDiscountIcon from './CampaignDiscountIcon';

const ctaButtonClassName =
  'inline-flex h-8 min-w-[134px] shrink-0 items-center justify-center rounded-full bg-coral-90 px-6 text-sm font-semibold leading-[21px] text-white transition-colors hover:bg-coral-96';

/**
 * Offer strip below the global header.
 * Mobile (Figma 7754:12826): stacked, centered copy + CTA.
 * Desktop (Figma 7754:12798): row with icon, copy, CTA (wraps on tablet).
 */
const CampaignPromoTopBanner = ({ onGetOfferClick }) => {
  const { topBanner, offerEndLong } = ELEVATED_CAMPAIGN_PROMO_UI;

  const ctaButton = (
    <ElementClickTracker {...SIGN_UP_ELEVATE_PRESENCE_TRACKING}>
      <button
        type="button"
        onClick={onGetOfferClick}
        className={ctaButtonClassName}
      >
        {topBanner.cta}
      </button>
    </ElementClickTracker>
  );

  return (
    <>
      <div
        className="flex w-full flex-col items-center gap-6 bg-deep-blue-70 px-6 py-6 font-hg-sans md:hidden"
        data-qa-target="campaign-promo-top-banner-mobile"
      >
        <div className="w-full max-w-[327px] text-center text-white">
          <p className="text-xl font-semibold leading-[25px]">
            {topBanner.leadBold.trim()}
          </p>
          <p className="text-xl font-extralight leading-[30px]">
            {topBanner.offerLight.trim()}
          </p>
          <p className="text-xs font-extralight leading-[18px]">
            Discount applied at checkout.
          </p>
          <p className="text-xs font-extralight leading-[18px]">
            Offer ends {offerEndLong.replace('December 31, ', '12/31/')}
          </p>
        </div>
        {ctaButton}
      </div>

      <div
        className="hidden min-h-16 w-full flex-row flex-wrap items-center justify-center gap-4 bg-deep-blue-70 px-4 py-4 font-hg-sans md:flex lg:gap-6 lg:px-2.5"
        data-qa-target="campaign-promo-top-banner"
      >
        <div className="flex min-w-0 flex-1 basis-[min(100%,20rem)] items-center gap-2 sm:basis-auto sm:flex-initial">
          <CampaignDiscountIcon />
          <p className="min-w-0 text-left text-white">
            <span className="text-xl font-semibold leading-[25px]">
              {topBanner.leadBold}
            </span>
            <span className="text-xl font-extralight leading-[30px]">
              {topBanner.offerLight}
            </span>
            <span className="text-xs font-extralight leading-[18px]">
              {topBanner.disclaimer}
            </span>
          </p>
        </div>
        {ctaButton}
      </div>
    </>
  );
};

CampaignPromoTopBanner.propTypes = {
  onGetOfferClick: PropTypes.func.isRequired,
};

export default CampaignPromoTopBanner;
